import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { salesPageSelectors } from '@/Pages/Sales/services';
import { documentPrintModalAsyncActions } from '@/ModalWindows/DocumentPrintModal/services/reducer';
import { documentPrintModalSelectors } from '@/ModalWindows/DocumentPrintModal/services/selectors';

export const useSelectDocumentOptions = () => {
  const dispatch = useDispatch();

  const selectedSale = useSelector(salesPageSelectors.selectedSale);
  const selectedTypeNumbers = useSelector(documentPrintModalSelectors.selectedTypeNumbers);
  const selectedDocumentTemplate = useSelector(documentPrintModalSelectors.selectedDocumentTemplate);

  useEffect(() => {
    if (selectedTypeNumbers?.[0].numbers?.length != 0 && selectedSale) {
      dispatch(
        documentPrintModalAsyncActions.getDocumentsForPrint({
          orderId: selectedSale.id,
          numbers: selectedTypeNumbers[0].numbers,
        }),
      );
    }
  }, [selectedTypeNumbers]);

  return {
    selectedDocumentTemplate,
  };
};
